export const EDITING_TOGGLE = 'EDITING_TOGGLE'
export const FETCH_EDITS = 'FETCH_EDITS'
// export const PERSON_EDITING_OPEN = 'PERSON_OPEN'
// export const EDITING_CLOSE = 'EDITING_CLOSE'



// WEBPACK FOOTER //
// ./src/modules/editing/actionTypes.js